var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M480-80q-18 0-35.5-6T412-105q-72-65-125.5-124.5t-88.5-115q-35-55.5-52.5-108T128-555q0-149 103-253.5T480-913q146 0 249 104.5T832-555q0 50-17.5 102.5t-52.5 108q-35 55.5-88.5 115T548-105q-15 13-32.5 19T480-80Zm0-390q37 0 63.5-26.5T570-560q0-37-26.5-63.5T480-650q-37 0-63.5 26.5T390-560q0 37 26.5 63.5T480-470Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPoint);
export default __webpack_public_path__ + "static/media/pin_point.85230e3e64f82a4fc6ff4575b16d85a1.svg";
export { ForwardRef as ReactComponent };